<template >
  <div class="organisation-dashboard" v-if="loaded && organisationDashboard.clientHash">
      <Hints />
      <div style="max-width: 940px">
        <div
          v-if="$vuetify.breakpoint.smAndUp"
          class="justify-space-between d-flex align-center"
        >
          <div
            v-if="orgs && orgs.length > 1"
            class="d-flex align-center mb-2 link-default"
            @click="$router.push(backToDashboardLink)"
          >
            <apio-icon size="16" lightModeColour="cyan" name="chevron-left" />
            Back to all organisations
          </div>
          <v-spacer/>
          <div v-if="currentOrganisation && currentOrganisation.apps > 0" class="organisation-dashboard__header--text p1-extra-bold mr-9">
            Available date range
          </div>
        </div>
      </div>
    <div
      v-if="$vuetify.breakpoint.xs"
      class="d-flex align-center mb-2 link-default"
      @click="$router.push(backToDashboardLink)"
    >
      <apio-icon size="16" lightModeColour="cyan" name="chevron-left" />Back
      to all organisations
    </div>


    <div
      class="organisation-dashboard__header mb-2"
      v-if="organisationDashboard && orgs"
    >

    <div v-if="orgs.length === 0">
      <apio-banner
        class="my-4"
        v-if="$mq === 'small' || $mq === 'medium' || $mq === 'large'"
        :size="'tall'"
        :title-text-size="'h1'"
        :title="'Create your first organisation'"
        :content-text="`You haven't created an organisation. Click below to create one.`"
        :background="'vibrant'"
        :content-text-colour="'white'"
        :title-text-colour="'white'"
      >
        <apio-button
          button-type="secondary"
          slot="button"
          style="text-transform: none"
          @click="createNewOrganisation"
          >Create organisation</apio-button
        >
      </apio-banner>

      <apio-banner
        class="mb-8"
        v-else
        :title="'Create your first organisation'"
        :content-text="`You have not created a new organisation yet. Click below to start`"
        :background="'vibrant'"
        :content-text-colour="'white'"
        :title-text-colour="'white'"
      >
        <apio-button
          button-type="secondary"
          slot="button"
          style="text-transform: none"
          @click="createNewOrganisation"
          >Create organisation</apio-button
        >
      </apio-banner>
    </div>

      <v-expansion-panels
        active-class=""
        v-if="$vuetify.breakpoint.xs"
        class="organisation-dashboard__details-accordion"
        flat
      >
        <v-expansion-panel @click="onExpansionPanelClick" color="purple">
          <v-expansion-panel-header
            :class="{ 'border-radius': headerBackgroundColor === 'cyan' }"
            class="organisation-dashboard__details-accordion--header white--text"
            :color="headerBackgroundColor"
          >
            <div class="p1-extra-bold">{{ organisationDashboard.name }}</div>
            <div>
                <apio-button
                  style="display: flex; align-items: center"
                  v-if="$mq !== 'small' && $mq !== 'medium'"
                  type="primary"
                  class="flex mr-4"
                  @click="newOrg"
                  >New Organisation

                  <apio-icon
                    name="ui-org-new"
                    class="ml-2"
                    size="28"
                    darkModeColour="white"
                    lightModeColour="white"
                  />
                </apio-button>
            </div>
            <template v-slot:actions>
              <apio-icon
                lightModeColour="white"
                darkModeColour="white"
                :name="headerIconName"
              >
                $expand
              </apio-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            class="organisation-dashboard__details-accordion--content"
            color="purple"
            v-if="orgs.length && apps !== null"
          >
            <div
              class="organisation-dashboard__header--text p2-extra-bold my-2"
            >
              Available date range
            </div>

            <div style="display: flex">
              <apio-date-range-picker
                class="organisation-dashboard__date-picker"
                opens="right"
                @update="updateDateRange"
                :start-date="organisationDashboardDateRange.startDate"
                :end-date="organisationDashboardDateRange.endDate"
              >
              </apio-date-range-picker>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div
        class="justify-space-between d-flex align-center"
        v-if="$vuetify.breakpoint.smAndUp"
        style="max-width: 940px"
      >
        <div class="h1" v-if="organisationDashboard">{{ organisationDashboard.name }}</div>
                    <div>
                <apio-button
                  style="display: flex; align-items: center"
                  v-if="$mq !== 'small' && $mq !== 'medium'"
                  type="primary"
                  class="flex mr-4"
                  @click="newOrg"
                  >New Organisation

                  <apio-icon
                    name="ui-org-new"
                    class="ml-2"
                    size="28"
                    darkModeColour="white"
                    lightModeColour="white"
                  />
                </apio-button>
            </div>
        <apio-date-range-picker
          v-if="currentOrganisation && currentOrganisation.apps > 0"
          class="organisation-dashboard__date-picker"
          opens="left"
          @update="updateDateRange"
          :start-date="organisationDashboardDateRange.startDate"
          :end-date="organisationDashboardDateRange.endDate"
        >
        </apio-date-range-picker>
      </div>
    </div>
    <div class="organisation-dashboard__summary-card-wrapper">
      <org-summary-card v-if="orgs && c" :c="c" />
      <EventDataAtAGlance
        :key="eventDataKey"
        v-if="organisationDashboard && organisationDashboardDates && c && organisationDashboard.apps !== null"
        :org-data="organisationDashboard"
        :clientHash="c"
        @updateData="updateData"
        @selectApp="selectAppEvent"
      />
      <div v-else>
      <apio-banner
        class="mt-0 mb-8"
        v-if="$mq==='xlarge'"
        :icon="'apps'"
        :title="'You haven\'t created any apps yet'"
        :type="'add_app'"
        :title-text-size="'h1'"
        :content-text="`Add at least one app to your organisation to get started.`"
      >
        <apio-button v-if="userBuildRights(c)" slot="button" @click="build">Create an App</apio-button>
      </apio-banner>
      <apio-banner
        v-else
        class="mt-0 mb-8"
        :icon="'apps'"
        size="tall"
        :title="'You haven\'t created any apps yet'"
        :type="'add_app'"
        :title-text-size="'h1'"
        :content-text="`Add at least one app to your organisation to get started.`"
      >
        <apio-button v-if="userBuildRights(c)" slot="button" @click="build">Create an App</apio-button>
      </apio-banner>
    </div>
    </div>
    <v-divider class="my-6 organisation-dashboard__divider" v-if="selectedApp && organisationDashboard && c && currentOrganisation.apps > 0 && currentOrganisation.interfaces > 0" />
    <AppInterfacesEventsChartWrapper v-if="organisationDashboard && currentOrganisation.apps > 0 && currentOrganisation.interfaces > 0" :a="selectedApp" :org-data="organisationDashboard" />

    <div v-if="users && users.length === 0 || (users.error && users.error.length)">
      <apio-banner
        class="mb-4"
        :size="'tall'"
        v-if="$mq === 'small' || $mq === 'medium' || $mq === 'large'"
        :icon="'users'"
        :type="'add_user'"
        :title-text-size="'h1'"
      >
        <apio-button
          button-type="secondary"
          slot="button"
          style="text-transform: none"
          @click="createNewUsers"
          >Invite users</apio-button
        >
      </apio-banner>

      <apio-banner
        class="mb-8 mt-8"
        v-else
        :icon="'users'"
        :type="'add_user'"
        :title-text-size="'h1'"
        :content-text="`Only you can access the organisation's apps and data. For other users to access the dashboard or build apps, add or invite them.`"
      >
        <apio-button
          button-type="secondary"
          slot="button"
          style="text-transform: none"
          @click="createNewUsers"
          >Invite users</apio-button
        >
      </apio-banner>
    </div>

  </div>
</template>

<script>
import { dashboard } from "@/mixins/dashboard.js";
import { mapGetters, mapState, mapActions } from "vuex";
import dayjs from "dayjs";
var utc = require("dayjs/plugin/utc"); // dependent on utc plugin
var timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
export default {
  name: "OrganisationDashboard",
  components: {
    Hints: () => import("@/components/Hints.vue"),
    ApioButton: () => import("@/components/Misc/Button.vue"),
    ApioBanner: () => import("@/components/Banner/Banner.vue"),
    OrgSummaryCard: () =>
      import("@/components/Organisations/OrgSummaryCard.vue"),
    ApioDateRangePicker: () => import("@/components/Misc/DateRangePicker.vue"),
    EventDataAtAGlance: () =>
      import("@/components/DoughnutChartTile/EventDataAtAGlance.vue"),
    AppInterfacesEventsChartWrapper: () => import("@/components/Dashboard/AppInterfacesEventsChartWrapper"),
  },
  mixins: [dashboard("orgs")],
  data() {
    return {
      hints: true,
      selectedApp: "*",
      chartDateRange: {
        startDate: dayjs.tz(this.$route.query.f * 1000 || dayjs.tz().startOf('day').day(-7)).utc(),
        endDate: dayjs.tz(this.$route.query.t * 1000 || dayjs.tz().endOf('day')).utc(),
      },
      headerBackgroundColor: "cyan",
      headerIconName: "chevron-down",
      eventDataKey: Math.random(),
      loaded: "",
    };
  },
  mounted() {
    this.setOrganisationDashboardDates({ startDate: this.chartDateRange.startDate.unix(), endDate: this.chartDateRange.endDate.unix() });
  },
  methods: {
    ...mapActions(["setOrganisationDashboardDates"]),
    updateDateRange(val) {
      this.$set(this.chartDateRange, 'startDate', dayjs.tz(val.startDate).startOf('day').utc());
      this.$set(this.chartDateRange, 'endDate', dayjs.tz(val.endDate).endOf('day').utc());
      this.setOrganisationDashboardDates({ startDate: dayjs.tz(val.startDate).startOf('day').utc().unix(), endDate: dayjs.tz(val.endDate).endOf('day').utc().unix() });
      this.updateData();
    },
    createNewOrganisation() {
      this.$router.push("/orgs/add");
    },
    onExpansionPanelClick(event) {
      if (
        event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        this.headerBackgroundColor = "cyan";
        this.headerIconName = "chevron-down";
      } else {
        this.headerBackgroundColor = "purple";
        this.headerIconName = "chevron-up";
      }
    },
    createNewUsers() {
      if (this.$route.query.c) {
        this.$router.push("/users/add?c="+this.$route.query.c);
      }
    },
    async updateData() {
      await this.$store.dispatch("getOrganisationData", {
        clientHash: this.c,
        appID: this.selectedApp ? this.selectedApp : false,
        timeStart: this.organisationDashboardDates.startDate || this.$route.query.f,
        timeEnd: this.organisationDashboardDates.endDate || this.$route.query.t,
        status: this.status,
      });
      this.eventDataKey = Math.random();
    },
    selectApp(appID) {
      this.selectedApp = appID;
      this.$store.dispatch("filterByApp", appID);
    },
    selectAppEvent(appID) {
      this.selectedApp = appID;
      this.$forceUpdate();
    },
    newOrg() {
      this.$router.push("/orgs/add");
    },
    build() {
      this.$router.push(`/build/?c=${this.c}`);
    },
  },
  computed: {
    ...mapGetters(['userBuildRights', 'userAdminRights', 'organisationDashboardDates']),
    ...mapState({
      currentOrganisation: (state) => state.orgs.currentOrganisation,
      organisations: (state) => state.orgs.orgs,
      organisationDashboard: (state) => state.orgs.organisationDashboard,
      orgs: (state) => state.orgs.orgs,
      users: (state) => state.users.users,
      organisationDashboardDateRange() {
        return this.chartDateRange;
      },
      backToDashboardLink() {
        const from = Math.floor(this.organisationDashboardDateRange.startDate / 1000);
        const to = Math.floor(this.organisationDashboardDateRange.endDate / 1000)
        return `/dashboard?f=${from}&t=${to}`;
      },
      c() {
        return this.$route.query.c || this.orgs[0]?.ID;
      }
    }),
    headerText() {
      return "Your Apio experience starts here…";
    },
    startDateUnix() {
      return (
        this.$route.query.f ||
        dayjs.tz(this.organisationDashboardDateRange.startDate).utc().unix()
      );
    },
    endDateUnix() {
      return (
        this.$route.query.t ||
        dayjs.tz(this.organisationDashboardDateRange.endDate).utc().unix()
      );
    },
  },
  async beforeRouteEnter (to, from, next) {
    await next(async vm => {
      await vm.updateData();
      await vm.$store.dispatch("fetchUsers", vm.id);
      await vm.$store.dispatch("fetchOrganisations");
      vm.loaded = true;
    });
  }
};
</script>

<style lang="scss" scoped>

.overlay {
  height: 100%;
  width: 100%;
  opacity: 0.5;
  color: black;
  z-index: 1000;
}
.organisation-dashboard {
  .theme--dark.v-application {
    color: white !important;
  }

  &__divider {
    max-width: 940px;
  }
  .border-radius {
    border-radius: 4px;
  }
  position: relative;
  margin-top: 4px;
  padding: 0 20px;
  &__details-accordion {
    margin-bottom: 16px;
    max-width: 292px;
    @media (max-width: 600px) {
      max-width: 320px;
    }
  }
  &__app {
    position: relative;
    list-style: none;
    padding: 0;
    margin: 0;
    &-item {
      margin: 0 0 2rem 0;
    }
    &-heading {
      margin: 0 0 1rem 0;
    }
  }
  &__charts {
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  }
  &__summary-card-wrapper {
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: repeat(12, 1fr);
    margin-top: 24px;
    @media (max-width: 970px) {
      grid-gap: 1rem;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: repeat(2, 1fr);
      justify-content: left;
    }
  }
  &__header {
    &--text {
      color: var(--apio-shade-2);
    }
    @media (max-width: 600px) {
      width: 100%;
      display: block;
    }
  }
}
</style>
